import React, { useState } from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import SendNotification from '@screens/Notifications/SendNotification';
import WhatsappManager from '@screens/Notifications/WhatsappManager';
import InternalTemplates from '@screens/Notifications/InternalTemplates';
import MessageLogView from '@screens/Notifications/MessageLogView';

/**
 * Centro de mensajes (2026-08-29, pedido de Irving).
 *
 * Dos tabs porque son dos canales con reglas muy distintas: los avisos internos
 * son gratis y se pueden mandar a discreción; **cada WhatsApp se cobra**, y sus
 * textos ni siquiera son editables (Meta los aprueba y quedan inmutables).
 * Ponerlos juntos deja esa diferencia a la vista de quien decide.
 *
 * ⚠️ Hoy los avisos llegan **solo al staff**. La réplica para los clientes en
 * krispis-web está acordada y pendiente: ahí manda D11 del plan — un aviso
 * masivo NO puede ser un documento por cada uno de los 14,427 clientes.
 */
const NotificationsScreen: React.FunctionComponent = () => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <Stack height="100%">
            <Tabs
                value={activeTab}
                onChange={(_, newValue) => setActiveTab(newValue)}
                variant="scrollable"
                sx={{ px: 2, pt: 1, flexShrink: 0 }}
            >
                <Tab label="Enviar aviso" />
                <Tab label="WhatsApp" />
                <Tab label="Avisos internos" />
                <Tab label="Historial de envíos" />
            </Tabs>
            {/* `minHeight: 0` o el hijo con height 100% empuja en vez de scrollear */}
            <Box flex={1} minHeight={0}>
                {activeTab === 0 && <SendNotification />}
                {activeTab === 1 && <WhatsappManager />}
                {activeTab === 2 && <InternalTemplates />}
                {activeTab === 3 && <MessageLogView />}
            </Box>
        </Stack>
    );
};

export default NotificationsScreen;
